var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwaiting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 0.333374C3.3217 0.333374 0.333008 3.32206 0.333008 7.00004C0.333008 10.678 3.3217 13.6667 6.99967 13.6667C10.6777 13.6667 13.6663 10.678 13.6663 7.00004C13.6663 3.32206 10.6777 0.333374 6.99967 0.333374ZM6.99967 0.999981C10.3172 0.999981 12.9997 3.68239 12.9997 6.99998C12.9997 10.3176 10.3173 13 6.99967 13C3.68209 13 0.999674 10.3176 0.999674 6.99998C0.999674 3.68239 3.68209 0.999981 6.99967 0.999981ZM6.99967 2.16662C6.81552 2.16662 6.66637 2.31589 6.66637 2.49992V6.99992C6.66637 7.12315 6.73357 7.22872 6.83309 7.28638C8.03285 7.97858 9.2402 8.67567 10.4423 9.36971C10.6018 9.46179 10.8034 9.40936 10.8955 9.24997C10.9876 9.09058 10.9351 8.88887 10.7758 8.79679L7.3329 6.80726V2.50012C7.3329 2.31597 7.18362 2.16681 6.99959 2.16681L6.99967 2.16662Z",
    fill: "#D37302"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaiting);
export default __webpack_public_path__ + "static/media/Awaiting.30462379b13e2786c4b9815053a8ed11.svg";
export { ForwardRef as ReactComponent };